import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { CloneRoleCommand } from 'src/app/core/api/models';
import { RolesService } from 'src/app/core/api/services';
import { BaseFormPageComponent } from 'src/app/pages/shared/base/components/base-form-page.component';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';


@Component({
    selector: 'app-roles-clone-form',
    templateUrl: './roles-clone-form.component.html',
    imports: [BaseFormModule]
})
export class RolesCloneFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region properties

  @Input() roleId: number;
  model: CloneRoleCommand = {};

  //#endregion
  constructor(protected currentService: RolesService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.title = 'pages.roles.form.cloneTitle';
  }

  initForm() {
    this.form = new FormGroup({
      name: new FormControl('', [Validators.required]),
      organizationName: new FormControl(''),
    });
  }

  //#region api

  //Create
  baseCreateApi(model: CloneRoleCommand) {
    this.loading = true;
    model.roleId = this.roleId;

    this.currentService
      .rolesClone({
        body: model,
      })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion
}
